import { hextorstr, KEYUTIL, KJUR, stob64 } from "jsrsasign";
// @ts-expect-error qz-tray
import qz from "qz-tray";
import { useCallback, useEffect, useState } from "react";

import { crt, privateKey } from "./const";

qz.security.setCertificatePromise((resolve: (crt: string) => void) => {
  resolve(crt);
});
qz.security.setSignatureAlgorithm("SHA512");
qz.security.setSignaturePromise(
  (toSign: string) => (resolve: (data: string) => void, reject: (error: unknown) => void) => {
    try {
      const pk = KEYUTIL.getKey(privateKey);
      const sig = new KJUR.crypto.Signature({ alg: "SHA512withRSA" });

      sig.init(pk);
      sig.updateString(toSign);
      const hex = sig.sign();

      resolve(stob64(hextorstr(hex)));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      reject(err);
    }
  },
);

const reloadQzPrinter = async () => {
  if (qz.websocket.isActive()) await qz.websocket.disconnect();

  return (
    qz.websocket
      .connect()
      // .connect({ host: "192.168.1.63" })
      .then(() => qz.printers.getDefault())
      .then((printer: unknown) => qz.configs.create(printer, { encoding: "UTF-8" }))
  );
};

type QzConfig = unknown;

const useQzPrinter = () => {
  const [config, setConfig] = useState<QzConfig>();

  useEffect(() => {
    qz.websocket.setClosedCallbacks(() => {
      setConfig(undefined);
    });

    return () => qz.websocket.setClosedCallbacks([]);
  }, []);

  const reloadPrinter = useCallback(
    async () =>
      await reloadQzPrinter()
        .then((printerConfig: QzConfig) => {
          setConfig(printerConfig);

          return printerConfig;
        })
        .catch((error) => {
          setConfig(undefined);
          throw error;
        }),
    [],
  );

  return useCallback(
    async (data: string | string[]) => {
      const qzConfig = config ?? (await reloadPrinter());

      if (Array.isArray(data)) {
        await qz.print(qzConfig, data);
      } else {
        await qz.print(qzConfig, [data]);
      }
    },
    [config, reloadPrinter],
  );
};

export { useQzPrinter };
